import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable ,  forkJoin } from 'rxjs';
import { Injectable } from '@angular/core';
import { ProductViewDataService } from './product-view-data.service';
import { ApiGatewayHelperService } from './../../app/services/apigateway-helper.service';
import { AuthService } from '../../app/services/auth.service';
import { AppHelperService } from 'modules/app/services/app-helper.service';
import { UserSettingsService } from './user-settings.service';
import { map } from 'rxjs/operators';
import { CreateUserAnalyticsService } from 'modules/learner/services/create-user-analytics.service';


@Injectable()
export class ProductViewResolverService  {
    constructor(private authService: AuthService,
        private productViewDataService: ProductViewDataService,
        private appHelperService: AppHelperService,
        private apiGatewayHelperService : ApiGatewayHelperService,
        private userSettingsService: UserSettingsService,
        private router: Router,
        private createUserAnalyticsService: CreateUserAnalyticsService
    ) { }
    
    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any {
        this.apiGatewayHelperService.setSpaceId(route.params.spaceid);
        let productCode = route.params.productcode;
        let assignmentId = route.params.assignmentid;
        let userData = this.authService.getUserData();
        const productViewObs =  this.productViewDataService.fetchAndStoreClassProductViewData(productCode, {
            classId: route.params.classid,
            assignmentId,
            unitCode: route.params.unitcode,
			activityId: route.params.activityId,
            accessToExpiredProduct: this.appHelperService.isProductReviewMode(),
            lgid: route.queryParams.ltiGiId,
        }).toPromise().then((productData: any)=> {
            //show error in case of empty response
            if(productData && productData.lgidType1ItemData && Object.keys(productData.lgidType1ItemData).length === 0) {
                this.appHelperService.navigateToOnboardingApp(['lti-onboarding-error', 'gradebookItemUrlInvalid']);
                return;
            }
            if (productData && productData.success === false) {
                if(productData.error == 'ASSIGNMENT_DOES_NOT_EXIST'){
                    this.appHelperService.navigateToOnboardingApp(['lti-onboarding-error', 'asssignmentDoesNotExist']);
                    return;
                }
                else if(productData.error == 'UA_NOT_PRESENT_ERROR') {
                    let redirectRoute = { url: state.url.split('?')[0], queryParams: route.queryParams };
                    this.createUserAnalyticsService.setUAMetaData(productData.userId, productData.orgId,  productData.pubnubEventType, redirectRoute);
                    this.router.navigate(['/learner', route.params.spaceid, 'createUA', 'product', route.params.productcode, 'class', route.params.classid]);
                    return;
                }
                this.appHelperService.showLoaderAndNavigateToDashboard(userData);
                return;
            }
            // NEMO-6677 : navigate away to dashboard as the product is suppressed.
            let bundleDetails = productData['bundleDetails'];
            let product = bundleDetails && bundleDetails.products && bundleDetails.products.find( (bundle) => bundle['dls-product'] && bundle['dls-product'].code === productCode);
            let suppressedAssignment = assignmentId && this.productViewDataService.isProductSuppressed(product, 'hide-assignments', route.params.spaceid);
            let suppressedLP = this.productViewDataService.isProductSuppressed(product, 'hide-learning-path', route.params.spaceid);
            let isAssignmentRoute = (state.url.includes("assignment") || assignmentId);
            if (isAssignmentRoute && suppressedAssignment) {
                this.appHelperService.navigateToDashboardApp([]);
            } else if (!isAssignmentRoute && (userData && userData.launchType != 'lti' && suppressedLP)) {
                this.appHelperService.navigateToDashboardApp([]);
            }

            return {
                'userProfileData': userData,
                'productData': productData
            }

        });   
        
        const tocSettingsObs = this.userSettingsService.getTOCSettingsForUser({spaceId: route.params.spaceid, classId: route.params.classid, productCode: productCode});
        return forkJoin(productViewObs, tocSettingsObs).pipe(
            map(response => {
                const productViewOData = response[0];
                productViewOData['userSettingsData'] = response[1];
                return productViewOData;
            })
        );
    }
}
